import { call, takeLatest } from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes"
import { OVERLAY_KEY_MULTISITE_SELECTOR } from "../../constants/overlayTypes"
import { getMultisiteSelectorCall } from "../../apis/wpApi/apiCalls"
import { checkResponse, overlaySetOverlay, putError, putSuccess } from "../helpers"
import authUser from "../../apis/wpApi/authUser"



export function* getMultisiteSelectorData(response) {
    if(!response.data) {
        throw new Error('No data from api')
    } else {
        return yield response.data
    }
}


function* getMultisiteSelector({payload}) {
    try {
        yield call(overlaySetOverlay, OVERLAY_KEY_MULTISITE_SELECTOR, false)

        const apiKey = yield call(authUser.getToken)
        const response = yield call(getMultisiteSelectorCall, apiKey, payload.signal)

        yield call(checkResponse, response, ['edited', 'items', 'order'])
        yield call(putSuccess, actionTypes.MULTISITE_SELECTOR_GET_SUCCESS, yield getMultisiteSelectorData(response), false)

    } catch(e) {
        yield call(putError, actionTypes.MULTISITE_SELECTOR_GET_ERROR, e.message, OVERLAY_KEY_MULTISITE_SELECTOR)
    }
}


function* watchMultisiteSelectorGetRequest() {
    yield takeLatest(actionTypes.MULTISITE_SELECTOR_GET_REQUEST, getMultisiteSelector);
}

export default watchMultisiteSelectorGetRequest